import { render } from "./ModalSurveyResult.vue?vue&type=template&id=05567b78"
import script from "./ModalSurveyResult.vue?vue&type=script&lang=js"
export * from "./ModalSurveyResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__